const Report = () => {
  return <>Reports Page</>;
};

export default Report;
